import { render, staticRenderFns } from "./ContactItem.vue?vue&type=template&id=563822f1&scoped=true&"
import script from "./ContactItem.vue?vue&type=script&lang=js&"
export * from "./ContactItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactItem.vue?vue&type=style&index=0&id=563822f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563822f1",
  null
  
)

export default component.exports